export const CONTENT_TYPE = [
  {
    value: 1,
    name: 'RockED',
  },
  {
    value: 2,
    name: 'OEM',
  },
  {
    value: 3,
    name: 'Partner',
  },
];

export const AGENDA_TYPE_OPTIONS = [
  { name: 'Upload File', value: 'file' },
  { name: 'Add Link', value: 'link' },
];

export const INITIAL_DATA = {
  name: '',
  type: 'file',
  url: '',
  file: null,
  filePreview: '',
  fileName: '',
};

export const INITIAL_RESOURCE_CARD_DATA = {
  name: '',
  type: 'file',
  url: '',
  file: null,
  filePreview: '',
  fileName: '',
};

export const MODE = { add: 'add', edit: 'edit' };
